export default function state() {
    return {
        fieldId: null,
        order: 0,
        published: false,
        level: 'basic',
        type: 0,
        types: [],
        card: '',
        cards: [],
        cardData: [],
        section: '',
        sectionData: [],
        step: '',
        stepData: [],
        page: '',
        pageData: '',
        name: '',
        helpModal: false,
        deleteModal: false,
        route: '',
        population: [],
        populations: [],
        submission: [],
        submissions: [],
        entry: [],
        postData: [],
        stockMedia: [],
        userMedia: [],
        hydrated: false,

        options: {
            audio: undefined,
            staticText: '',

            helpText: '',
            helpTitle: '',

            loadStock: 'no',
            uploadType: 'image',
            showUploadButton: 'no',
            showSelectButton: 'no',
            uploaderInstructionText: '',

            customColorUpsell: '',
            customFontUpsell: '',
            customColorAccessLevel: 'plus',
            customFontAccessLevel: 'plus',
            upsell: '',


            fieldsInGroup: 1,
            groupNumbered: false,
            groupInline: false,
            group: [],

            templateSelector: {
                label: 'Sample Color Scheme',
                colorOne: '#ef6067',
                colorTwo: '#366780',
                colorThree: '#f5f5f5',
            },

            heroSelector: {
                label: 'Hero Background',
                choiceOne: 'Image',
                choiceTwo: 'Theme Color',
            },

            training: {
                description: undefined,
                video: {
                    id: undefined,
                    thumbnail: {
                        id: undefined,
                        src: undefined,
                    },
                },

                download: {
                    id: undefined,
                    url: undefined,
                }
            },

            preview: {
                heroImage: undefined,
                heroImageSrc: undefined,
                heroHeadline: undefined,
                heroSubhead: undefined,
                heroButtonText: undefined,
                banner1: undefined,
                banner2: undefined,
                banner3: undefined,
                headshot: undefined,
                headshotSrc: undefined,
                bodyHeadline: undefined,
                bodyCopy: undefined,
                bodyButtonText: undefined,
            }
        }
    };
}
